import {
  AreaProperties,
  PointFeatureCollection,
  PointProperties,
  OldAreaFeatureCollection,
} from '@/api/modules/delivery/types'

/**
 * Мапинг страой модели points в новую модель
 * @param points - Список старых точек
 */
export const mapPoints = (
  points: PointFeatureCollection,
): PointProperties[] => {
  return points.features.map(({ id, properties, geometry }) => {
    return {
      address: properties.address,
      cafe: properties.cafe,
      cooking_time: properties.cooking_time,
      coordinates: geometry.coordinates,
      how_to_find: properties.how_to_find,
      id,
      is_open: properties.is_open,
      slug: properties.slug,
      tags: properties.tags,
      working_hours: properties.working_hours,
    }
  })
}

/**
 * Мапинг страой модели areas в новую модель
 * @param areas - Список старых полигонов
 */
export const mapAreas = (areas: OldAreaFeatureCollection): AreaProperties[] => {
  return areas.features.map(({ id, properties, geometry }) => {
    return {
      id,
      polygon: geometry.coordinates,
      properties: {
        cooking_time: properties.cooking_time,
        costs: properties.costs,
        delivery_time: properties.delivery_time,
        free_delivery_from: properties.free_delivery_from,
        min_price: properties.min_price,
        stroke: properties.stroke,
      },
    }
  })
}
